export default __webpack_public_path__ + "static/media/arrow-right.e5673ee5.svg";